import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './DownloadPage.css';

const DownloadPage: React.FC = () => {
  return (
<div className="min-vh-100 d-flex flex-column underwater-background">
  {/* Bulles d'eau */}
  {Array.from({ length: 20 }).map((_, i) => (
    <div key={i} className="bubble" />
  ))}
      {/* Background Whale with immersive effect */}
      <div className="whale-immersion-container">
        <img
          src="/Whale2.png"
          alt="Baleine immersive"
          className="whale-immersive"
        />
        <div className="water-light-effects"></div>
      </div>
      {/* Header */}
      <header className="py-4 position-relative z-1">
        <Container>
          <div className="d-flex align-items-center">
            <img
              src="/appmobile.png"
              alt="Logo Tohora Ture"
              style={{
                height: '60px',
                width: '60px',
                borderRadius: '16px',
                marginRight: '15px',
                border: '3px solid white',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              }}
            />
            <h1 className="mb-0 fw-bold" style={{ letterSpacing: '1px' }}>
              TOHORA TURE
            </h1>
          </div>
        </Container>
      </header>

      {/* Main Content */}
      <main className="flex-grow-1 d-flex align-items-center justify-content-center text-center position-relative z-1">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <h2 className="display-5 fw-bold mb-3">
                Téléchargez l'application
              </h2>

              <p className="lead mb-3">
                Tohorā Ture permet de suivre en temps réel les observations de
                baleines et d’encadrer les interactions en mer.
              </p>
              <p className="mb-4" style={{ fontSize: '1.05rem' }}>
                L’outil indispensable des Navires autorisés par la DIREN en
                Polynésie française.
              </p>

              <div className="d-flex flex-column align-items-center gap-4 my-4">
                <img
                  src="/appmobile.png"
                  alt="Icône application TOHORA TURE"
                  style={{
                    width: '180px',
                    height: '180px',
                    borderRadius: '40px',
                    border: '6px solid white',
                    boxShadow: '0 15px 35px rgba(0,0,0,0.35)',
                  }}
                />

                <div className="d-flex flex-row gap-3 justify-content-center">
                  <a
                    href="https://apps.apple.com/us/app/tohor%C4%81-ture/id6740665472"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                      alt="App Store"
                      style={{ height: '50px' }}
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=pf.magis.regdiren&pcampaignid=web_share"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                      alt="Google Play"
                      style={{ height: '50px' }}
                    />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </main>

      {/* Footer */}
          <footer className="py-4 text-center text-lg-start position-relative z-1">
        <Container>
          <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center gap-3">
            <img
              src="/diren.png"
              alt="Logo DIREN Polynésie"
              style={{
                height: '48px',
                borderRadius: '6px',
                backgroundColor: 'white',
                padding: '4px',
              }}
            />
            <p
              className="mb-0 small text-center text-lg-start"
              style={{ fontSize: '0.9rem' }}
            >
              Direction de l'Environnement Polynésie Française
            </p>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default DownloadPage;
